import React from 'react';

import {assert} from 'Asserts';
import {FilterKey, GenericFilter} from 'search/SearchConstants';
import ProjectSelector from 'ui-library/ProjectSelector';
import pick from 'util/pick';

import {BaseFilterFormProps, BASE_FILTER_FORM_PROP_NAMES, FilterStyle} from './base/FilterFormConstants';
import SecondaryFilterFormSkeleton from './base/SecondaryFilterFormSkeleton';

export interface QueryApiProjectFilterFormProps extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.QUERY_API_PROJECT>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.QUERY_API_PROJECT>) => void;
  onRemove?: () => void;
}

export default function QueryApiProjectFilterForm(props: QueryApiProjectFilterFormProps): JSX.Element {
  assert(
    props.filterStyle === FilterStyle.SECONDARY,
    'Project filter only configured to work as secondary filter'
  );
  const skeletonProps = pick(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const searchInput = (
    <ProjectSelector
      selectorModalZIndex={1060}
      selectedProjectId={props.filter.value}
      onProjectSelected={(newProjectId) => {
        props.onChangeFilter({...props.filter, value: newProjectId});
      }}
      enableRedesign={true}
    />
  );

  return (
    <SecondaryFilterFormSkeleton
      {...skeletonProps}
      nodeGrid={[[searchInput]]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove!}
    />
  );
}
